import * as types from './types'

export const getFacilities = (payload: any) => ({
  type: types.GET_FACILITIES,
  payload,
})

export const getFacility = (payload: any) => ({
  type: types.GET_FACILITY,
  payload,
})

export const addFacility = (payload: any) => ({
  type: types.ADD_FACILITIES,
  payload,
})

export const editFacility = (payload: any) => ({
  type: types.EDIT_FACILITIES,
  payload,
})

export const submitFacility = (payload: any) => ({
  type: types.SUBMIT_FACILITY,
  payload,
})

export const rejectFacility = (payload: any) => ({
  type: types.REJECT_FACILITY,
  payload,
})

export const approveFacility = (payload: any) => ({
  type: types.APPROVE_FACILITY,
  payload,
})

export const deleteFacility = (payload: any) => ({
  type: types.DELETE_FACILITY,
  payload,
})

export const getFacilityHistory = (payload: any) => ({
  type: types.GET_FACILITY_HISTORY,
  payload,
})

export const getLockedFacilities = (payload: any) => ({
  type: types.GET_LOCKED_FACILITIES,
  payload,
})

export const startLoadingFacilities = () => ({
  type: types.START_LOADING_FACILITIES,
  payload: null,
})

export const stopLoadingFacilities = () => ({
  type: types.STOP_LOADING_FACILITIES,
  payload: null,
})

export const getFacilitySnapshot = (payload: any) => ({
  type: types.GET_FACILITY_SNAPSHOT,
  payload,
})

export const getFacilityAmounts = (payload: any) => ({
  type: types.GET_FACILITY_AMOUNTS,
  payload,
})

export const getFacilityAmount = (payload: any) => ({
  type: types.GET_FACILITY_AMOUNT,
  payload,
})

export const getFacilityAmountRequest = () => ({
  type: types.GET_FACILITY_AMOUNT_REQUEST,
  payload: null,
})

export const getFacilityAmountFailure = () => ({
  type: types.GET_FACILITY_AMOUNT_FAILURE,
  payload: null,
})

/** Placed or lifted a facility lock — the lists that show holds reload. */
/**
 * A lock placed or lifted. `holds` is the facility's holds as the hold
 * transaction left them, from the ledger's own answer: the grid shows them at
 * once. Without them the grid can only mark itself stale and reload — from
 * PQS, which may not have projected the lock yet.
 */
export const facilityHoldChanged = (payload: { facilityId: string; holds?: unknown[] }) => ({
  type: types.FACILITY_HOLD_CHANGED,
  payload,
})
